var map = {
	"./Games_container_background_rosu.webp": 8397,
	"./Games_container_background_verde.webp": 7794,
	"./active.webp": 7798,
	"./active_de.webp": 4008,
	"./banda_neon_Tableta_x2_v2.webp": 1510,
	"./bg.webp": 2941,
	"./bg2.webp": 1916,
	"./bg3.webp": 7140,
	"./bg_overlay.webp": 4554,
	"./btn_shap.webp": 8377,
	"./g1.webp": 2853,
	"./g2.webp": 563,
	"./g3.webp": 7397,
	"./g4.webp": 4334,
	"./g5.webp": 558,
	"./g6.webp": 7755,
	"./g7.webp": 9726,
	"./g8.webp": 710,
	"./gp.webp": 7524,
	"./i2.webp": 8181,
	"./i3.webp": 6929,
	"./i4.webp": 6503,
	"./i5.webp": 1231,
	"./i6.webp": 9806,
	"./i7.webp": 1209,
	"./i8.webp": 6214,
	"./icon_B-BALL_rosu.webp": 6149,
	"./icon_B-BALL_verde.webp": 3669,
	"./icon_BALANCE_rosu.webp": 8659,
	"./icon_BALANCE_verde.webp": 7438,
	"./icon_BEAMS_rosu.webp": 2685,
	"./icon_BEAMS_verde.webp": 1029,
	"./icon_BUTTONS_rosu.webp": 1071,
	"./icon_BUTTONS_verde.webp": 2376,
	"./icon_ESCALADE_rosu.webp": 1817,
	"./icon_ESCALADE_verde.webp": 1262,
	"./icon_HIDE-N-SEEK_rosu.webp": 8552,
	"./icon_HIDE-N-SEEK_verde.webp": 2383,
	"./icon_SQUARES_rosu.webp": 7699,
	"./icon_SQUARES_verde.webp": 7672,
	"./icon_SUPER-SQUARES_rosu.webp": 4768,
	"./icon_SUPER-SQUARES_verde.webp": 6086,
	"./icon_THROW_rosu.webp": 7778,
	"./icon_THROW_verde.webp": 1960,
	"./icon_TUBES_rosu.webp": 7984,
	"./icon_TUBES_verde.webp": 1374,
	"./icon_WARZONE_rosu.webp": 4029,
	"./icon_WARZONE_verde.webp": 9879,
	"./icon_token_Energize_mov.webp": 8644,
	"./input.webp": 2828,
	"./logo1.webp": 2493,
	"./logo1v2.webp": 4738,
	"./logo2.webp": 3218,
	"./man.webp": 6318,
	"./n1.webp": 7842,
	"./n2.webp": 7507,
	"./n3.webp": 2330,
	"./n4.webp": 9229,
	"./n5.webp": 4168,
	"./n6.webp": 4445,
	"./n7.webp": 105,
	"./n8.webp": 4691,
	"./p_g.webp": 7183,
	"./p_n.webp": 3311,
	"./submit.webp": 7379,
	"./summary_bg.webp": 3577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4190;